import { render } from "./IconHistory.vue?vue&type=template&id=3332dcac"
import script from "./IconHistory.vue?vue&type=script&lang=ts"
export * from "./IconHistory.vue?vue&type=script&lang=ts"
script.render = render

export default script